import { useEffect, useState } from 'react';
import './MediaContentList.scss';
import { ContentCarrier } from 'models';
import { usePlaywatchKids } from './Context';
import KidsCard from './KidsCard';
import { MediaItem } from './interfaces';
import { formatPlayTime } from './utils';
import { ResourcePropertyType } from 'features/enumerations';
export default function MediaContentList({ contentCarrier }: { contentCarrier: ContentCarrier }) {
    const [media, setMedia] = useState([]);
    const { setSelectedMedia, selectedMedia } = usePlaywatchKids()
    useEffect(() => {
        let temp = [];
        contentCarrier?.media?.categories.map(x => temp.push(...x.media.filter(x => x.id !== selectedMedia?.id)));
        setMedia(temp);
    }, [contentCarrier, selectedMedia?.id])

    if (!media?.length) {
        return <></>
    }

    return <>
        <MediaList onMediaStart={(media) => {
            setSelectedMedia(media);
        }} media={media} />
    </>
}

interface MediaGridProps {
    media: MediaItem[];
    onMediaStart: (media: MediaItem) => void
}

const MediaList: React.FC<MediaGridProps> = ({ onMediaStart, media }) => (
    <div className="media-list">
        {media.map((item, index) => {
            let thumbNameState = item.states.find(x => x.resourcePropertyType === ResourcePropertyType.Thumbnail)
            let gifState = item.states.find(x => x.resourcePropertyType === ResourcePropertyType.GifPreview)
            return (
                <KidsCard key={index}
                    thumbnailUrl={thumbNameState.url}
                    duration={`${formatPlayTime(item.duration)}`}
                    gifUrl={gifState?.url || thumbNameState.url}
                    title={item.name}
                    onClick={() => {
                        onMediaStart(item);
                    }}
                    description={item.description} />
            )
        })}
    </div>
);